export default __webpack_public_path__ + "static/media/deployed-green.11dea298.svg";